// import { ReactNode } from "react";
// import {
//   dashboard,
//   payments,
//   settings,
//   toggles,
//   verify,
// } from "../assets/images";
// import { MdOutlineDashboard } from "react-icons/md";

// export const dashboardMenu: {
//   name: string;
//   icon: ReactNode;
// }[] = [
//   {
//     name: "Dashboard",
//     icon: <MdOutlineDashboard />,
//   },
//   {
//     name: "Profile",
//     icon: <MdOutlineDashboard />,
//   },
//   {
//     name: "Payments",
//     icon: <MdOutlineDashboard />,
//   },
//   {
//     name: "Settings",
//     icon: <MdOutlineDashboard />,
//   },
// ];

import { ReactNode } from "react";
import { IconType } from "react-icons";
import { FaRegStar } from "react-icons/fa6";
import { IoSettingsOutline } from "react-icons/io5";
import { LuShieldCheck } from "react-icons/lu";
import { MdOutlineDashboard, MdOutlinePayments } from "react-icons/md";

export const dashboardMenu: {
  name: string;
  icon: IconType;
  link: string;
}[] = [
  {
    name: "Dashboard",
    icon: MdOutlineDashboard,
    link: "",
  },
  // {
  //   name: "Payments",
  //   icon: MdOutlinePayments,
  //   link: "payments",
  // },
  {
    name: "Reviews",
    icon: FaRegStar,
    link: "reviews",
  },
  {
    name: "Profile",
    icon: LuShieldCheck,
    link: "profile",
  },
  {
    name: "Settings",
    icon: IoSettingsOutline,
    link: "settings",
  },
];
